module.exports = __webpack_public_path__ + "img/card_ip_stipulation43.7c3f26e6.svg";